export default __webpack_public_path__ + "static/media/icon-transfer.ba4c772e.svg";